import React, { useState, useEffect } from "react";
import { Download, X } from "lucide-react";

export default function PWAInstall() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("np_pwa_dismissed")) return;
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setTimeout(() => setShow(true), 6000);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
    setDeferred(null);
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("np_pwa_dismissed", "1");
  };

  if (!show) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-5 left-5 z-[60] max-w-sm bg-white rounded-2xl shadow-2xl shadow-brand-emerald/30 border border-[#D6E4DC] p-4 flex items-center gap-3 animate-pop-in"
    >
      <img src="/assets/icon-192.png" alt="Neat & Proper app icon" className="w-12 h-12 rounded-xl" />
      <div className="flex-1">
        <p className="font-display font-bold text-brand-emerald text-sm">Install Neat &amp; Proper</p>
        <p className="text-xs text-brand-muted">Book cleanings faster — right from your home screen.</p>
      </div>
      <div className="flex flex-col gap-1.5">
        <button data-testid="pwa-install-btn" onClick={install} className="px-3 py-1.5 rounded-full bg-brand-emerald text-white text-xs font-bold hover:bg-brand-lime transition-colors flex items-center gap-1">
          <Download className="w-3 h-3" /> Install
        </button>
        <button data-testid="pwa-dismiss-btn" onClick={dismiss} className="text-xs text-brand-muted hover:text-brand-emerald flex items-center justify-center gap-1">
          <X className="w-3 h-3" /> Not now
        </button>
      </div>
    </div>
  );
}
